import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  createRoute,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import { getAuthToken } from '@/shared/api/trpc';
import { RootLayout } from '../layout';

export type RouterContext = {
  queryClient: QueryClient;
};

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

export const protectedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'protected',
  component: Outlet,
  beforeLoad: async ({ location }) => {
    // Local/dev: API uses DEV_BYPASS_AUTH + DEV_USER_EMAIL — no Clerk token.
    if (import.meta.env.VITE_DEV_BYPASS_AUTH === 'true') {
      return;
    }
    const token = await getAuthToken();
    if (!token) {
      throw redirect({
        to: '/sign-in',
        // `location.search` is TanStack Router's *parsed* search — a
        // null-prototype object. Concatenating it with `+` coerces it to a
        // primitive and throws `Cannot convert object to primitive value`
        // (no inherited toString/valueOf), crashing beforeLoad to the root
        // ErrorBoundary for any signed-out visit. `location.searchStr` is the
        // raw query string (`?...`, or `''` when absent) — safe to concat.
        search: { redirect_url: location.pathname + location.searchStr },
      });
    }
  },
});

export { Outlet, redirect };
